import Mock from "fake-db/mock";
import "./db/notification";
Mock.onAny().passThrough();
